import { render, staticRenderFns } from "./senders-input-status.vue?vue&type=template&id=f9006354&"
import script from "./senders-input-status.vue?vue&type=script&lang=js&"
export * from "./senders-input-status.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports